import { jobStatus, jobStatusTitle, laneTitle, truckOf, unitLabel } from './serviceTickets';

function esc(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function truckLine(ticket) {
    const truck = truckOf(ticket);
    return [truck.year, truck.make, truck.model, truck.type].filter(Boolean).join(' ');
}

function ticketBlock(ticket) {
    const jobs = (ticket.items || []).filter((item) => String(item.text || '').trim());
    const rows = jobs.length
        ? jobs.map((item) => `
            <tr>
                <td>${esc(item.text)}</td>
                <td>${esc(jobStatusTitle(jobStatus(item)))}</td>
                <td>${esc(item.note || '')}</td>
            </tr>`).join('')
        : '<tr><td colspan="3">No jobs</td></tr>';
    const down = ticket.down ? '<span class="down">DOWN</span>' : '';
    return `
        <section>
            <h2>${esc(unitLabel(ticket))} ${down}</h2>
            <p class="meta">${esc(truckLine(ticket))} · ${esc(laneTitle(ticket.status))}</p>
            ${ticket.notes ? `<p class="notes">${esc(ticket.notes)}</p>` : ''}
            <table>
                <thead><tr><th>Job</th><th>Status</th><th>Note for the driver</th></tr></thead>
                <tbody>${rows}</tbody>
            </table>
        </section>`;
}

export function printShopWorkList(tickets) {
    const rows = (tickets || []).filter(Boolean);
    if (!rows.length) {
        window.alert('Nothing to print.');
        return;
    }
    const printed = new Date().toLocaleString(undefined, {
        month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
    });
    const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<title>Shop work list</title>
<style>
    @page { size: letter; margin: 0.5in; }
    body { font-family: Arial, Helvetica, sans-serif; color: #1c1917; margin: 0; }
    header { display: flex; justify-content: space-between; align-items: baseline; border-bottom: 3px solid #E94F37; padding-bottom: 8px; margin-bottom: 16px; }
    h1 { font-size: 22px; margin: 0; }
    .when { font-size: 12px; color: #57534e; }
    section { break-inside: avoid; margin: 0 0 18px; }
    h2 { font-size: 20px; margin: 0; }
    .down { display: inline-block; margin-left: 8px; padding: 2px 6px; background: #c62828; color: white; font-size: 12px; letter-spacing: 0.04em; vertical-align: middle; }
    .meta, .notes { margin: 4px 0 8px; font-size: 13px; color: #44403c; }
    table { width: 100%; border-collapse: collapse; }
    th, td { border: 1px solid #d6d3d1; padding: 6px 8px; text-align: left; font-size: 13px; vertical-align: top; }
    th { background: #f5f5f4; }
    td:nth-child(2) { width: 130px; white-space: nowrap; }
</style>
</head>
<body>
<header>
    <h1>Shop work list</h1>
    <div class="when">Printed ${esc(printed)}</div>
</header>
${rows.map(ticketBlock).join('')}
<script>window.onload = function () { window.print(); };</script>
</body>
</html>`;
    const win = window.open('', '_blank');
    if (!win) {
        window.alert('Allow pop-ups to print the work list.');
        return;
    }
    win.document.open();
    win.document.write(html);
    win.document.close();
}
